// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WizardServicos_CarregaCompromissoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /wizard_servicos/carrega_compromisso
 *
 * Object dados: the compromisso with servicos array
 */
import type { WizardServicos_CarregaCompromissoCompromissoRow } from './WizardServicos_CarregaCompromissoCompromissoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface WizardServicos_CarregaCompromissoResponseDados {
compromisso: WizardServicos_CarregaCompromissoCompromissoRow
}

export type WizardServicos_CarregaCompromissoResponse = ApiResponse<WizardServicos_CarregaCompromissoResponseDados>;

registerResponseContract('WizardServicos_CarregaCompromissoResponse', {
  compromisso: {
    type: 'object',
    required: true,
    fields: {
      compromisso_id:                    { type: 'number',  required: false },
      compromisso_titulo:                { type: 'string',  required: false },
      title:                             { type: 'string',  required: false },
      compromisso_total:                 { type: 'string',  required: false },
      backgroundColor:                   { type: 'string',  required: false },
      compromisso_data_hora_inicio:      { type: 'string',  required: false },
      start:                             { type: 'string',  required: false },
      compromisso_data_hora_fim:         { type: 'string',  required: false },
      end:                               { type: 'string',  required: false },
      compromisso_data_cadastro:         { type: 'string',  required: false },
      compromisso_operador_user_id:      { type: 'string',  required: false },
      compromisso_orcamento_id:          { type: 'number',  required: false },
      compromisso_franquia_id:           { type: 'number',  required: false },
      compromisso_forma_pagamento:       { type: 'number',  required: false },
      compromisso_forma_pagamento_label: { type: 'string',  required: false },
      compromisso_numero_parcelas:       { type: 'number',  required: false },
      compromisso_nome_cliente:          { type: 'string',  required: false },
      compromisso_observacao:            { type: 'string',  required: false },
      compromisso_origem:                { type: 'number',  required: false },
      orcamento_origem:                  { type: 'number',  required: false },
      compromisso_status:                { type: 'string',  required: false },
      compromisso_status_original:       { type: 'string',  required: false },
      compromisso_foi_reagendado:        { type: 'number',  required: false },
      compromisso_tipo:                  { type: 'number',  required: false },
      compromisso_checkin:               { type: 'string',  required: false },
      compromisso_checkout:              { type: 'string',  required: false },
      compromisso_entrou_sem_problemas:  { type: 'number',  required: false },
      compromisso_status_financeiro:     { type: 'number',  required: false },
      compromisso_valor_recebido:        { type: 'string',  required: false },
      cliente_id:                        { type: 'number',  required: false },
      cliente_location_id:               { type: 'number',  required: false },
      cliente_location_type:             { type: 'string',  required: false },
      cliente:                           { type: 'string',  required: false },
      franquia_nome:                     { type: 'string',  required: false },
      localidade:                        { type: 'string',  required: false },
      status_financeiro:                 { type: 'string',  required: false },
      nome_operador:                     { type: 'string',  required: false },
      avatar_operador:                   { type: 'string',  required: false },
      borderColor:                       { type: 'string',  required: false },
      franchise_id:                      { type: 'number',  required: false },
      valor_restante:                    { type: 'number',  required: false },
      valor_total:                       { type: 'number',  required: false },
      compromisso_valor_total:           { type: 'number',  required: false },
      servicos: {
        type: 'array',
        required: false,
        items: {
          compromisso_servico_id:            { type: 'number',  required: true },
          compromisso_id:                    { type: 'number',  required: false },
          orcamento_servico_id:              { type: 'number',  required: false },
          compromisso_servico_status:        { type: 'number',  required: false },
          compromisso_servico_qtd:           { type: 'number',  required: false },
          compromisso_servico_valor:         { type: 'number',  required: false },
          compromisso_servico_data_cadastro: { type: 'string',  required: false },
          compromisso_servico_observacao:    { type: 'string',  required: false },
          servicoscategoria_id:              { type: 'number',  required: false },
          servico_id:                        { type: 'number',  required: false },
          servico_nome:                      { type: 'string',  required: false },
          tem_imagens_antes:                 { type: 'boolean', required: false },
          tem_imagens_depois:                { type: 'boolean', required: false },
        },
      },
      servicos_compromisso: {
        type: 'array',
        required: false,
        items: {
          compromisso_servico_id:            { type: 'number',  required: true },
          compromisso_id:                    { type: 'number',  required: false },
          orcamento_servico_id:              { type: 'number',  required: false },
          compromisso_servico_status:        { type: 'number',  required: false },
          compromisso_servico_qtd:           { type: 'number',  required: false },
          compromisso_servico_valor:         { type: 'number',  required: false },
          compromisso_servico_data_cadastro: { type: 'string',  required: false },
          compromisso_servico_observacao:    { type: 'string',  required: false },
          servicoscategoria_id:              { type: 'number',  required: false },
          servico_id:                        { type: 'number',  required: false },
          servico_nome:                      { type: 'string',  required: false },
          tem_imagens_antes:                 { type: 'boolean', required: false },
          tem_imagens_depois:                { type: 'boolean', required: false },
        },
      },
      operador: {
        type: 'object',
        required: false,
        fields: {
          first_name: { type: 'string',  required: false },
          image:      { type: 'string',  required: false },
        },
      },
    },
  },
})
